import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/authSlice';

export default function Layout({ children }) {
  const dispatch = useDispatch();
  const { user } = useSelector((s) => s.auth);
  const [collapsed, setCollapsed] = useState(false);

  const links = [
    { to: '/', icon: 'bi-speedometer2', label: 'Supervision' },
    { to: '/signs', icon: 'bi-signpost-split', label: 'Panneaux virtuels' },
    { to: '/sign-types', icon: 'bi-collection', label: 'Types signalisation' },
    { to: '/alerts', icon: 'bi-exclamation-triangle', label: 'Alertes' },
    { to: '/infractions', icon: 'bi-shield-slash', label: 'Infractions' },
    { to: '/sos', icon: 'bi-shield-exclamation', label: 'SOS' },
  ];

  return (
    <>
      <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="logo">
          <i className="bi bi-shield-check"></i> <span className="logo-text">YEBELA</span>
        </div>
        <button className="collapse-btn" onClick={() => setCollapsed(!collapsed)}>
          <i className={`bi ${collapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
        </button>
        <nav>
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <i className={`bi ${l.icon}`}></i> <span className="nav-label">{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div style={{ position: 'absolute', bottom: 16, left: 0, width: '100%', padding: '0 16px' }}>
          {!collapsed && (
            <div style={{ color: '#888', fontSize: 12, marginBottom: 8 }}>
              {user?.first_name || user?.phone}
            </div>
          )}
          <button
            className="btn btn-outline-danger btn-sm w-100"
            onClick={() => dispatch(logout())}
            title="Déconnexion"
          >
            <i className="bi bi-box-arrow-right"></i>{!collapsed && ' Déconnexion'}
          </button>
        </div>
      </div>
      <div className={`main-content ${collapsed ? 'sidebar-collapsed' : ''}`}>
        {children}
      </div>
    </>
  );
}
